export const GET_PAGE_COMPONENTS = "GET_PAGE_COMPONENTS";
